import ProjectsPage from "./ProjectsPage"

export default { "/projects": ProjectsPage, "/projects/*": ProjectsPage }
